<template>
  <div>
    <v-img
      :src="require('@/assets/dotted_bck.png')"
      style="position: absolute; max-width: 50vw"
    ></v-img>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "CurrentTrip",
  props: ["tripId"],

  created() {
    console.log("home created, current user is ", this.$store.state.firUser.uid);
    const { tripId } = this.$props;
    console.log("current trip created with tripId:", tripId);

    if (tripId) {
      const { currentTripId } = this.$store.getters;
      if (!currentTripId || currentTripId !== tripId) {
        this.$store.dispatch("observeNewTrip", tripId);
      } else {
        console.log("reusing trip");
      }
    }
  },
  computed: {
    trip() {
      return this.$store.state.trip.trip;
    },
  },
  watch: {
    trip(trip) {
      if (trip) {
        console.log("setting colors for company");
        const company = this.$store.getters.tripCompany;
        if (company && company.primary_color) {
          this.$vuetify.theme.themes.light.primary = company.primary_color;
          this.$vuetify.theme.themes.light.secondary = company.secondary_color;
          return;
        }
      }
      this.$vuetify.theme.themes.light.primary = "#5D74E2";
      // this.$vuetify.theme.themes.light.secondary = ...
    },
  },
};
</script>
